import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { apiRoutes } from "configs/apiRoutes";
import instance from "api/apiClient";
import { useAppSelector } from "store/index";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;
  handleUpdateType: (e: { value: string | number; label: string }[]) => void;
  selectedType: { value: string | number; label: string }[];
  handleUpdateStatus: (e: { value: string | number; label: string }[]) => void;
  selectedStatus: { value: string | number; label: string }[];
  handleUpdateCurrency: (
    e: { value: string | number; label: string }[]
  ) => void;
  selectedCurrency: { value: string | number; label: string }[];
  handleApply: () => void;
}
const BonusesFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,
  handleUpdateType,
  selectedType,
  handleUpdateStatus,
  selectedStatus,
  handleUpdateCurrency,
  selectedCurrency,
  handleApply,
}) => {
  const { t } = useTranslation();

  const currenciesList = useAppSelector((store) => store.settings.currencies);

  const [Type, setType] = useState<{ value: string | number; label: string }[]>(
    []
  );
  const [Status, setStatus] = useState<
    { value: string | number; label: string }[]
  >([]);

  const getType = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.bonusesTypesList}?limit=500&offset=0`
      );
      const array = result.data.items.map((el: any) => {
        return {
          value: el.id,
          label: el.title,
        };
      });
      setType(array);
    } catch (error) {
      console.log(error, "error");
    }
  };
  const getStatus = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.bonusesStatusList}?limit=500&offset=0`
      );
      const array = result.data.items.map((el: any) => {
        return {
          value: el.id,
          label: el.title,
        };
      });
      setStatus(array);
    } catch (error) {
      console.log(error, "error");
    }
  };
  useEffect(() => {
    getType();
    getStatus();
  }, []);
  const handleApplyType = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateType && selectedType)
      handleUpdateType(isDelete ? e : [...e]);
  };
  const handleApplyStatus = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateStatus && selectedStatus)
      handleUpdateStatus(isDelete ? e : [...e]);
  };
  const handleApplyCurrency = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateCurrency && selectedCurrency)
      handleUpdateCurrency(isDelete ? e : [...selectedCurrency, ...e]);
  };

  const handleClearFilters = () => {
    handleUpdateType([]);
    handleUpdateStatus([]);
    handleUpdateCurrency([]);
    handleSearch("");
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      search={searchValue}
      onSearch={handleSearch}
      placeholder={t("searchEntity")}
      searchLabel={t("title")}
      filterItems={[
        {
          type: FilterItemTypes.select,
          title: t("status"),
          boxTitle: t("status"),
          icon: gridIcon,
          itemsArray: Status,
          activeItems: selectedStatus,
          handleApply: handleApplyStatus,
          disabled: Status.length === 0,
        },
        {
          type: FilterItemTypes.select,
          title: t("type"),
          boxTitle: t("type"),
          icon: gridIcon,
          itemsArray: Type,
          activeItems: selectedType,
          handleApply: handleApplyType,
          disabled: Type.length === 0,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("currency"),
          boxTitle: t("currency"),
          icon: gridIcon,
          itemsArray: currenciesList?.map((el) => {
            return {
              label: el,
              value: el,
            };
          }) ?? [],
          activeItems: selectedCurrency,
          handleApply: handleApplyCurrency,
          disabled: currenciesList.length === 0,
        },
      ]}
    />
  );
};

export default BonusesFilter;
